import './ButtonDivider.scss';

const ButtonDivider = () => {
  return (
    <div className="divider-container mt-5 d-inline-flex justify-content-center">
      <div className="line-divider mt-2"></div>
      <div className="mx-3 divider-text">ou</div>
      <div className="line-divider mt-2"></div>
    </div>
  );
};

export default ButtonDivider;